import request from '@/utils/request'

export function listNotice(query) {
  return request({
    url: '/notice/list',
    method: 'get',
    params: query
  })
}

export function createNotice(data) {
  return request({
    url: '/notice/create',
    method: 'post',
    data
  })
}

export function deleteNotice(data) {
  return request({
    url: '/notice/delete',
    method: 'post',
    data
  })
}

export function replyNotice(data) {
  return request({
    url: '/notice/reply',
    method: 'post',
    data
  })
}
